module.exports = __webpack_public_path__ + "img/jumpfeed-full-light.7a173c2b.svg";